<sn-searchbar
  (valueChange)="onSearchValueChange($event)"
  (search)="onSearchValueChange($event)"
  [placeholder]="'map.locations.search.searchByCaseName' | t"
></sn-searchbar>
<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="this.queryParams.search">
    <sn-data-list #listElement [fetchFn]="loadData">
      <sn-infinite-scroll>
        <sn-pull-to-refresh>
          <ng-template [ngIf]="list?.dataSource?.data?.length" [ngIfThen]="table"></ng-template>
          <ng-template
            [ngIf]="!list?.dataSource?.data?.length && list?.dataIsInited"
            [ngIfThen]="emptyList"
          ></ng-template>
        </sn-pull-to-refresh>
      </sn-infinite-scroll>
    </sn-data-list>
  </ng-container>
  <ng-container *ngIf="!this.queryParams.search">
    <sn-empty-state icon="search" [title]="'map.locations.search.enterSearchTerm' | t"></sn-empty-state>
  </ng-container>
  <ng-template #table>
    <sn-incident-case-search-table
      [columns]="columns"
      [items]="list.dataSource.data"
      (itemTap)="select($event)"
    >
    </sn-incident-case-search-table>
  </ng-template>

  <ng-template #emptyList>
    <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
      {{ 'common.noResultsMatchSearch' | t }}
    </sn-empty-state>
  </ng-template>
</mat-dialog-content>
